import { State } from "@/store/modules/invitation/index";

const setInvitations = (state: State, payload) => {
  state.invitations = payload;
};

const deleteInvitations = (state: State, payload) => {
  state.invitations = [];
};
export default {
  setInvitations,
  deleteInvitations,
};
